/** @format */

export function filter(filter) {
  console.error("Filter function is missing.", section, filter, id, "~4");
  return this;
}
